<template src="./template.html"></template>
<script>
import EventCarousel from 'components/EventCarousel'
import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'

export default {
  name: 'event-carousel-widget',
  mixins: [iframeWidgetBaseMixin],
  data() {
    let theme = this.$route.query.theme

    //TODO: should eventually get the venue to update their code
    //
    if (this.$route.query.venueId === 'c0bbbe1523a0df1a') {
      //NOTE: hardcode Shrine to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === '5efcb2374941fe55') {
      //NOTE: hardcode Aura Tempe to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === '964169aca553472b') {
      //NOTE: hardcode Scorpion Patriot Place to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === 'f623598b9750fa99') {
      //NOTE: hardcode GEM to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === 'b52419ff8811ca1a') {
      //NOTE: hardcode Club Boca to fix their widget colors
      theme = 'theme-dark'
    }
    if (this.$route.query.venueId === 'af570dc9775899fb') {
      //NOTE: hardcode Bodega Canal to fix their widget colors
      theme = 'theme-dark'
    }

    return {
      venueId: this.$route.query.venueId,
      attributionId: this.$route.query.attributionId,
      eventCount: parseInt(this.$route.query.eventCount, 10),
      eventDisplayType: this.$route.query.eventDisplayType,
      slidesToShow: this.$route.query.slidesToShow ? parseInt(this.$route.query.slidesToShow, 10) : null,
      slidesToScroll: this.$route.query.slidesToScroll ? parseInt(this.$route.query.slidesToScroll, 10) : null,
      autoplay: this.$route.query.autoplay === 'true',
      headerImages: this.$route.query.headerImages === 'true',
      theme,
    }
  },
  components: {
    EventCarousel,
  },
  methods: {
    onUpdated() {
      this.publishDimensions()
    },
    onEventClicked(event) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.EVENT_CLICKED,
          iframeId: this.iframeId,
          data: {
            event,
            eventId: event.id,
            attributionId: this.attributionId,
          },
        },
        {
          parent: true,
        }
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/EventCarousel/index.vue